export enum RangeType {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  LAST_UNIT = 'LAST_UNIT',
  TIME = 'TIME'
}
